var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityListings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14771 4.66806L7.00696 14L9.85099 4.66735L4.14771 4.66806Z",
    fill: "#64B7E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85099 4.66633L4.14771 4.66562L5.45659 -2.52175e-05H8.53691L9.85099 4.66633Z",
    fill: "#90CCEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46543 0L4.19061 4.66633H0L3.37013 0H5.46543Z",
    fill: "#BCE0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53433 0L9.80915 4.66633H13.9998L10.6296 0H8.53433Z",
    fill: "#64B7E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99949 14L4.19061 4.66735H0L6.99949 14Z",
    fill: "#90CCEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00027 14L9.80915 4.66735H13.9998L7.00027 14Z",
    fill: "#2399D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityListings);
export default __webpack_public_path__ + "static/media/QualityListings.3331e400c931e9087494f5239beb3638.svg";
export { ForwardRef as ReactComponent };